import { render, staticRenderFns } from "./apps-view.vue?vue&type=template&id=32ba354e&scoped=true"
import script from "./apps-view.vue?vue&type=script&lang=js"
export * from "./apps-view.vue?vue&type=script&lang=js"
import style0 from "./apps-view.vue?vue&type=style&index=0&id=32ba354e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba354e",
  null
  
)

export default component.exports